// extracted by mini-css-extract-plugin
module.exports = {"forgotPasswordPage":"ForgotPasswordPage_forgotPasswordPage__2pMFd","forgotPassword":"ForgotPasswordPage_forgotPassword__1_-aK"};